import PropTypes from 'prop-types';
import React from 'react';
import isFinite from 'lodash/isFinite';
import floor from 'lodash/floor';

import Money from '../../../../common/money';

const MIN_BIG_PRICE = 10000000; // $100,000.00 in cents
const MIN_BIG_NUMBER = 1000;

const FormatNumber = ({ children, format, bigPriceThreshold, automationId }) => {
  if (!isFinite(children)) return <div>&nbsp;</div>;
  const minBigNumber = format === 'price' ? bigPriceThreshold : MIN_BIG_NUMBER;
  const isBig = children > minBigNumber;
  const suffix = isBig ? 'K' : '';
  const parsed = isBig ? floor(children / 1000, 1) : children;

  return (
    <div>
      <Money display-if={format === 'price'} automationId={automationId}>{parsed}</Money>
      <span display-if={format !== 'price'} data-automation-id={automationId}>{parsed}</span>{suffix}
    </div>
  );
};
FormatNumber.propTypes = {
  children: PropTypes.number,
  format: PropTypes.oneOf(['price', '']),
  bigPriceThreshold: PropTypes.number,
  automationId: PropTypes.string,
};
FormatNumber.defaultProps = {
  format: '',
  bigPriceThreshold: MIN_BIG_PRICE,
  automationId: null,
};

export default FormatNumber;
